/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown>, maxSize: NonNullable<unknown> }} Conversion_Error_Document_Too_LargeInputs */

const en_conversion_error_document_too_large = /** @type {(inputs: Conversion_Error_Document_Too_LargeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This document is ${i?.size}. The maximum is ${i?.maxSize}.`)
};

const es_conversion_error_document_too_large = /** @type {(inputs: Conversion_Error_Document_Too_LargeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este documento ocupa ${i?.size}. El máximo es ${i?.maxSize}.`)
};

/**
* | output |
* | --- |
* | "This document is {size}. The maximum is {maxSize}." |
*
* @param {Conversion_Error_Document_Too_LargeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_document_too_large = /** @type {((inputs: Conversion_Error_Document_Too_LargeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Document_Too_LargeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_document_too_large(inputs)
	return en_conversion_error_document_too_large(inputs)
});